const targetElement = '.v-table__wrapper tr:first-child > :first-child';
const vuetifyStickyHeaderClass = 'v-data-table-column--fixed';
/**
 *
 * @param store vuexStore
 * @param targetParentNode 부모 테이블
 * @returns
 */
export const tableScrollTop = (vuexStore, targetParentNode) => {
    const unsubscribe = vuexStore.watch((state, getters) => getters['hubSelector/getterSubscribeHubId'], (value, oldValue) => {
        const selectedHubId = value;
        if (!selectedHubId
            || oldValue === selectedHubId) {
            return;
        }
        const firstRow = targetParentNode.querySelector(targetElement);
        if (!firstRow) {
            return;
        }
        // 혹 헤더가 Sticky면 1번 타겟이 항상 보이므로 스크롤이 이동하지 않음.(2번으로 이동 시 덜 이동)
        const isStickyTableHeader = firstRow.className.includes(vuetifyStickyHeaderClass);
        if (!isStickyTableHeader) {
            firstRow.scrollIntoView(false);
            return;
        }
        // sticky 해제 -> 스크롤 이동 -> sticky 재적용
        firstRow.style.setProperty('position', 'static', 'important');
        firstRow.scrollIntoView(false);
        firstRow.style.setProperty('position', 'sticky', 'important');
    });
    return unsubscribe;
};
